import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
export const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {}
});
export default collectionsSlice.reducer;
export const selectCollections = state => state.collections.list;
export const selectCollectionSlugs = state => state.collections.list.map(({
  slug
}) => `/${slug}`);
export const selectDisplayedCollections = state => state.collections.list.filter(({
  displayed
}) => displayed);
export function isStaticCollection(collection) {
  return collection.query !== undefined;
}